import { PersonaErrorType } from "@next-platform/client-common-core";

export const PERSONA_ERRORS = {
  [PersonaErrorType.CREATE_PERSONA]: "Unable to create persona.",
  [PersonaErrorType.UPDATE_PERSONA]: "Unable to update persona.",
  [PersonaErrorType.DELETE_PERSONA]: "Unable to delete persona.",
  [PersonaErrorType.GET_PERSONA]: "Unable to get persona.",
  [PersonaErrorType.SET_DEFAULT_PERSONA]: "Unable to set default persona.",
  [PersonaErrorType.DELETE_DEFAULT_PERSONA]: "Unable to delete default persona.",
  [PersonaErrorType.GET_DEFAULT_PERSONA]: "Unable to get default persona.",
  [PersonaErrorType.CHANGE_PERSONA]: "Unable to change persona.",
  [PersonaErrorType.NO_PERSONA_FOUND]: "No persona found.",
  [PersonaErrorType.NO_DEFAULT_PERSONA_FOUND]: "No default persona found.",
  [PersonaErrorType.NO_PERSONA_SELECTED]: "No persona selected.",
};
